/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Pricing_ContactInputs */

const en_agent_authorization_pricing_contact = /** @type {(inputs: Agent_Authorization_Pricing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact for pricing`)
};

const zh_agent_authorization_pricing_contact = /** @type {(inputs: Agent_Authorization_Pricing_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系询价`)
};

/**
* | output |
* | --- |
* | "Contact for pricing" |
*
* @param {Agent_Authorization_Pricing_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_pricing_contact = /** @type {((inputs?: Agent_Authorization_Pricing_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Pricing_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_pricing_contact(inputs)
	return zh_agent_authorization_pricing_contact(inputs)
});
export { agent_authorization_pricing_contact as "agent.authorization.pricing.contact" }